import { render } from "./UiDataTable.vue?vue&type=template&id=231b86ca"
import script from "./UiDataTable.vue?vue&type=script&lang=js"
export * from "./UiDataTable.vue?vue&type=script&lang=js"

import exportComponent from "D:\\laragon\\www\\leader-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__